/**
 * MangoService — Intégration Mango via CJ Affiliate
 * Publisher ID: 101729219
 */
import { Linking } from 'react-native';

const CJ_PUBLISHER_ID  = '101729219';
const MANGO_ADVERTISER_ID = '15891178'; // Mango Advertiser ID CJ

// ─── Générer un lien affilié CJ pour un produit Mango ────────
export function getMangoAffiliateUrl(productUrl, userId = '') {
  if (!MANGO_ADVERTISER_ID) return productUrl; // fallback si pas encore configuré
  const base    = `https://www.anrdoezrs.net/click-${CJ_PUBLISHER_ID}-${MANGO_ADVERTISER_ID}`;
  const encoded = encodeURIComponent(productUrl);
  const sid     = userId ? `&sid=${userId}` : '';
  return `${base}?url=${encoded}${sid}`;
}

// ─── Ouvrir un lien Mango avec tracking CJ ───────────────────
export async function openMangoProduct(productUrl, userId = '') {
  const affiliateUrl = getMangoAffiliateUrl(productUrl, userId);
  try {
    await Linking.openURL(affiliateUrl);
  } catch(e) {
    console.warn('[MANGO] openURL error:', e.message);
  }
}

// ─── Produits Mango fallback (hardcodés avec vrais liens) ─────
export function getFallbackMangoProducts(gender = 'F', category = '') {
  const all = gender === 'M' ? MANGO_MAN : MANGO_WOMAN;
  if (!category || category === 'Tout') return all;
  return all.filter(p => p.category === category);
}

// ─── Catalogue femme Mango ────────────────────────────────────
const MANGO_WOMAN = [
  {
    id: 'mng_w_001', partner: 'mango', brand: 'Mango',
    name: 'Blazer structuré cropped', category: 'Vestes',
    price: 79.99, emoji: '🧥', color: 'Noir',
    image: 'https://st.mngbcn.com/rcs/pics/static/T7/fotos/S20/77080669_99_B.jpg',
    url: getMangoAffiliateUrl('https://shop.mango.com/fr/femme/vestes/blazer-structure-cropped_77080669.html'),
    available: true, partner_badge: '#E50010',
  },
  {
    id: 'mng_w_002', partner: 'mango', brand: 'Mango',
    name: 'Robe mi-longue satinée', category: 'Robes',
    price: 59.99, emoji: '👗', color: 'Bordeaux',
    image: 'https://st.mngbcn.com/rcs/pics/static/T7/fotos/S20/77093753_67_B.jpg',
    url: getMangoAffiliateUrl('https://shop.mango.com/fr/femme/robes/robe-mi-longue-satinee_77093753.html'),
    available: true, partner_badge: '#E50010',
  },
  {
    id: 'mng_w_003', partner: 'mango', brand: 'Mango',
    name: 'Jean straight taille haute', category: 'Bas',
    price: 49.99, emoji: '👖', color: 'Bleu',
    image: 'https://st.mngbcn.com/rcs/pics/static/T7/fotos/S20/57003795_70_B.jpg',
    url: getMangoAffiliateUrl('https://shop.mango.com/fr/femme/jeans/jean-straight-taille-haute_57003795.html'),
    available: true, partner_badge: '#E50010',
  },
  {
    id: 'mng_w_004', partner: 'mango', brand: 'Mango',
    name: 'Trench classique ceinturé', category: 'Vestes',
    price: 99.99, emoji: '🧥', color: 'Camel',
    image: 'https://st.mngbcn.com/rcs/pics/static/T7/fotos/S20/57009757_47_B.jpg',
    url: getMangoAffiliateUrl('https://shop.mango.com/fr/femme/manteaux/trench-classique-ceinture_57009757.html'),
    available: true, partner_badge: '#E50010',
  },
  {
    id: 'mng_w_005', partner: 'mango', brand: 'Mango',
    name: 'Top satiné col V', category: 'Hauts',
    price: 29.99, emoji: '👚', color: 'Ivoire',
    image: 'https://st.mngbcn.com/rcs/pics/static/T7/fotos/S20/67090551_04_B.jpg',
    url: getMangoAffiliateUrl('https://shop.mango.com/fr/femme/tops/top-satine-col-v_67090551.html'),
    available: true, partner_badge: '#E50010',
  },
  {
    id: 'mng_w_006', partner: 'mango', brand: 'Mango',
    name: 'Sac shopper cuir', category: 'Sacs',
    price: 69.99, emoji: '👜', color: 'Camel',
    image: 'https://st.mngbcn.com/rcs/pics/static/T7/fotos/S20/17090502_47_B.jpg',
    url: getMangoAffiliateUrl('https://shop.mango.com/fr/femme/sacs/sac-shopper-cuir_17090502.html'),
    available: true, partner_badge: '#E50010',
  },
  {
    id: 'mng_w_007', partner: 'mango', brand: 'Mango',
    name: 'Escarpins talon carré', category: 'Chaussures',
    price: 59.99, emoji: '👠', color: 'Noir',
    image: 'https://st.mngbcn.com/rcs/pics/static/T7/fotos/S20/17055127_99_B.jpg',
    url: getMangoAffiliateUrl('https://shop.mango.com/fr/femme/chaussures/escarpins-talon-carre_17055127.html'),
    available: true, partner_badge: '#E50010',
  },
  {
    id: 'mng_w_008', partner: 'mango', brand: 'Mango',
    name: 'Collier doré minimaliste', category: 'Bijoux',
    price: 19.99, emoji: '💍', color: 'Or',
    image: 'https://st.mngbcn.com/rcs/pics/static/T7/fotos/S20/57090507_97_B.jpg',
    url: getMangoAffiliateUrl('https://shop.mango.com/fr/femme/bijoux/collier-dore-minimaliste_57090507.html'),
    available: true, partner_badge: '#E50010',
  },
];

// ─── Catalogue homme Mango Man ────────────────────────────────
const MANGO_MAN = [
  {
    id: 'mng_m_001', partner: 'mango', brand: 'Mango Man',
    name: 'Blazer slim fit', category: 'Vestes',
    price: 89.99, emoji: '🧥', color: 'Marine',
    image: 'https://st.mngbcn.com/rcs/pics/static/T7/fotos/S20/67080773_17_B.jpg',
    url: getMangoAffiliateUrl('https://shop.mango.com/fr/homme/vestes/blazer-slim-fit_67080773.html'),
    available: true, partner_badge: '#E50010',
  },
  {
    id: 'mng_m_002', partner: 'mango', brand: 'Mango Man',
    name: 'Chino slim coton', category: 'Bas',
    price: 45.99, emoji: '👖', color: 'Beige',
    image: 'https://st.mngbcn.com/rcs/pics/static/T7/fotos/S20/57010787_06_B.jpg',
    url: getMangoAffiliateUrl('https://shop.mango.com/fr/homme/pantalons/chino-slim-coton_57010787.html'),
    available: true, partner_badge: '#E50010',
  },
  {
    id: 'mng_m_003', partner: 'mango', brand: 'Mango Man',
    name: 'Chemise oxford slim', category: 'Hauts',
    price: 39.99, emoji: '👔', color: 'Blanc',
    image: 'https://st.mngbcn.com/rcs/pics/static/T7/fotos/S20/67090581_01_B.jpg',
    url: getMangoAffiliateUrl('https://shop.mango.com/fr/homme/chemises/chemise-oxford-slim_67090581.html'),
    available: true, partner_badge: '#E50010',
  },
];

// ─── Tag impression CJ (à insérer sur l'écran principal) ─────
// Publisher ID: 101729219
export const CJ_IMPRESSION_TAG = `https://www.anrdoezrs.net/am/${CJ_PUBLISHER_ID}/include/allCj/exclude/7204907/impressions/page/am.js`;
